var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #1e5288;\n        stroke-linecap: round;\n        stroke-width: 2px;\n      }\n\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(-0.443 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    className: "cls-1",
    width: 77,
    height: 77,
    transform: "translate(1.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    className: "cls-1",
    d: "M225.771,332.528l28-28.359,28,28.359-27.063,27.641Z",
    transform: "translate(-214.327 -294.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    className: "cls-2",
    d: "M211.388,326.767l37.5-37.107,37.5,37.107L249.74,364.66Z",
    transform: "translate(-208.751 -289.092)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1211",
    "data-name": "Line 1211",
    className: "cls-1",
    x2: 10,
    transform: "translate(67.5 37.848)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1212",
    "data-name": "Line 1212",
    className: "cls-1",
    x2: 7.476,
    transform: "translate(4.024 37.848)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape4);
export default __webpack_public_path__ + "static/media/shape-4.7fed10156e174f4b1f18de62fce8bc6b.svg";
export { ForwardRef as ReactComponent };